import Vue from 'vue'
import VViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(VViewer)
